import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { ToastrService } from 'ngx-toastr';
import { PreAssessmentService } from 'src/app/core/services/api-services/pre-assessments.service';

@Component({
  selector: 'app-add-courier-for-transfer-prscription',
  templateUrl: './add-courier-for-transfer-prscription.component.html',
  styleUrls: ['./add-courier-for-transfer-prscription.component.scss']
})

export class AddCourierForTransferPrscriptionComponent {
  warning: boolean = false;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  disableButton: boolean;
  constructor(public dialogRef: MatDialogRef<AddCourierForTransferPrscriptionComponent>,
    private fb: FormBuilder,
    public preAssessmentService: PreAssessmentService,
    public toast: ToastrService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.disableButton = false;
    this.initializeForm();
  }
  initializeForm() {
    this.form = this.fb.group({
      name: new FormControl("", [Validators.required]),
      type: new FormControl(this.props.item.receipt.status, [Validators.required]),
    });
  }
  formSubmit() {

    if (this.form.valid) {
      let payload = {
        ...this.form.value,
        name: this.form.value.name,
        type: this.form.value.type
      }

     this.isLoading = true;
      this.disableButton = true;
      this.preAssessmentService.prescriptionCourierAdd(payload).subscribe(res => {
        this.isLoading = false;
        if (res.body.success) {
          this.dialogRef.close({ response: res.body });
          this.toast.success(res.body.message);
        }
        else {
          this.disableButton = false;
          this.toast.error(res.body.message);
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
}
